import { css } from '@emotion/react';
import { theme } from 'global';

export const dialogWithNoPadding = css`
  .MuiDialogContent-root {
    padding: 0px !important;
  }
`;

export const mobileDialog = css`
  &.MuiDialog-root {
    .MuiDialog-container {
      align-items: center !important;
      justify-content: center !important;
    }

    .MuiDialog-paper {
      margin: 16px !important;
      max-width: calc(100vw - 32px) !important;
      position: relative !important;
      transform: none !important;
      border-radius: 16px !important;
    }
  }

  &.MuiDialog-root .MuiDialog-scrollBody {
    align-items: center !important;
    justify-content: center !important;
  }
`;

export const dialogInfoBox = css`
  display: flex;
  flex-direction: column;
  align-items: start;
  padding-left: 24px;
  padding-right: 24px;
  padding-bottom: 24px;
  padding-top: 32px;
  gap: 24px;
`;

export const dialogButton = css`
  display: flex;
  flex-direction: column;
  height: 74px;
  justify-content: space-between;
  align-items: end;
  padding: 12px 16px 12px 16px;
  border-top: 1px solid ${theme.colors.neutral[100]};
`;

export const explanationBox = css`
  display: flex;
  flex-direction: column;
  width: 472px;
  gap: 8px;

  @media (max-width: ${theme.breaks.sm}px) {
    width: 100%;
  }
`;

export const explanationListItem = css`
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: start;
  width: 472px;
  &.MuiListItem-gutters {
    padding-left: 0px;
  }

  @media (max-width: ${theme.breaks.sm}px) {
    width: 100%;
  }
`;

export const explanationListItemIcon = css`
  width: 24px;
  display: flex;
  align-items: start;
`;

export const explanationListItemText = css`
  width: 472px;

  @media (max-width: ${theme.breaks.sm}px) {
    width: calc(100% - 24px);
  }
`;

export const creditLimit = css`
  width: 472px;
  height: 24px;

  @media (max-width: ${theme.breaks.sm}px) {
    width: 100%;
  }
`;

export const menu = css`
  .MuiMenu-list {
    width: 241px;
    max-height: none;
  }
`;

export const menuSpacing = css`
  justify-content: space-between;
`;

export const menuItemBox = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 12px;
  height: 66px;
`;

export const iconButtonNoHover = css`
  &:hover {
    background-color: transparent;
  }
  &.MuiIconButton-root:hover {
    background-color: transparent;
  }
`;

export const menuLogo = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 40px;
  padding: 8px;
  gap: 8px;
  border-radius: 4px;
  background-color: ${theme.colors.neutral[50]};
  &:hover {
    background-color: ${theme.colors.neutral[100]};
  }
`;
